import { GenericService } from '@/services/api/generic.service';
import { SurveyResult } from '@/custom/menicon/models';

export class MeniconSurveyResultsService extends GenericService<SurveyResult> {

  constructor(patientId: string) {
    super(`menicon/v1/patients/${patientId}/virtual-doctor/survey-results`);
  }
}
